/**
 * WhatsApp Templates Frontend Configuration
 * This file serves as the source of truth for template categorization in the frontend
 * Updated: AUTOMATIC templates (10) and MANUAL templates (10)
 */

export const WHATSAPP_TEMPLATES_CONFIG = {
  AUTOMATIC: {
    otp: {
      key: 'otp',
      templateName: 'otp_temp',
      description: 'Send OTP verification code to user',
      category: 'automatic',
      icon: '🔐',
    },
    match_making_request: {
      key: 'match_making_request',
      templateName: 'smmm_match_req',
      description: 'Notify candidate about a new matchmaking request',
      category: 'automatic',
      icon: '💌',
    },
    welcome: {
      key: 'welcome',
      templateName: 'sign_up_comp',
      description: 'Send welcome/onboarding message to new users',
      category: 'automatic',
      icon: '👋',
    },
    premium_match_profile: {
      key: 'premium_match_profile',
      templateName: 'network_troubleshooting_20',
      description: 'Share premium match profile highlights',
      category: 'automatic',
      icon: '⭐',
    },
    not_premium_match: {
      key: 'not_premium_match',
      templateName: 'smm_matches_temp',
      description: 'Send match details for non-premium users',
      category: 'automatic',
      icon: '🎯',
    },
    like: {
      key: 'like',
      templateName: 'order_management_no_cta_5',
      description: 'Notify user that someone liked their profile',
      category: 'automatic',
      icon: '❤️',
    },
    smm_del_acc: {
      key: 'smm_del_acc',
      templateName: 'smm_del_acc',
      description: 'Admin-facing lead interest and feedback notification',
      category: 'automatic',
      icon: '👤',
    },
    smm_web_temp: {
      key: 'smm_web_temp',
      templateName: 'smm_web_temp',
      description: 'Smart Matrimony web template with CTA button',
      category: 'automatic',
      icon: '🌐',
    },
    smm_payment_temp: {
      key: 'smm_payment_temp',
      templateName: 'smm_payment_temp',
      description: 'Payment success confirmation with package details',
      category: 'automatic',
      icon: '💳',
    },
    smm_matches_temp: {
      key: 'smm_matches_temp',
      templateName: 'smm_matches_temp',
      description: 'Match notification template',
      category: 'automatic',
      icon: '💑',
    },
    smm_details_temp: {
      key: 'smm_details_temp',
      templateName: 'smm_details_temp',
      description: 'Admin notification for profile actions',
      category: 'manual',
      icon: '📋',
    },
    premium_match_status: {
      key: 'premium_match_status',
      templateName: 'send_premium_no_match_status_whatsapp_new',
      description: 'Personalized status update for premium members',
      category: 'manual',
      icon: '📊',
    },

  },

  MANUAL: {
    
    smm_action_notice: {
      key: 'smm_action_notice',
      templateName: 'smm_action_notice',
      description: 'Ask user to confirm/update their job location',
      category: 'manual',
      icon: '📍',
    },
    smmelan_video_template: {
      key: 'smmelan_video_template',
      templateName: 'smmelan_video_template',
      description: 'Sammelan promo video template with steps and support',
      category: 'manual',
      icon: '🎥',
    },
    smm_thankyou_community: {
      key: 'smm_thankyou_community',
      templateName: 'send_community_thankyou_template',
      description: 'Community thank-you broadcast for members milestone',
      category: 'manual',
      icon: '🙏',
    },
    smm_income_temp: {
      key: 'smm_income_temp',
      templateName: 'smm_income_temp',
      description: 'Ask user to reconfirm their annual financial income',
      category: 'manual',
      icon: '💰',
    },
    smm_seriousness_check: {
      key: 'smm_seriousness_check',
      templateName: 'smm_seriousness_check_new',
      description: 'Verify if user is genuinely serious about marriage',
      category: 'manual',
      icon: '✅',
    },
    smm_feedback_temp: {
      key: 'smm_feedback_temp',
      templateName: 'smm_feedback_temp_new',
      description: 'Feedback template for users',
      category: 'manual',
      icon: '⭐',
    },
    smm_astrology_survey: {
      key: 'smm_astrology_survey',
      templateName: 'astrology_importance_survey_temp',
      description: 'Check how important astrology is for user matches',
      category: 'manual',
      icon: '♈',
    },
    smig_temp: {
      key: 'smig_temp',
      templateName: 'smig_temp',
      description: 'App redirect template with CTA button',
      category: 'manual',
      icon: '🔗',
    },
  },
};

/**
 * Get all templates as a flat list
 */
export const getAllTemplates = () => {
  return {
    ...WHATSAPP_TEMPLATES_CONFIG.AUTOMATIC,
    ...WHATSAPP_TEMPLATES_CONFIG.MANUAL,
  };
};

/**
 * Get templates by category
 */
export const getTemplatesByCategory = (category) => {
  if (category === 'automatic') return WHATSAPP_TEMPLATES_CONFIG.AUTOMATIC;
  if (category === 'manual') return WHATSAPP_TEMPLATES_CONFIG.MANUAL;
  return {};
};

/**
 * Check if template is automatic
 */
export const isAutomaticTemplate = (templateKey) => {
  return templateKey in WHATSAPP_TEMPLATES_CONFIG.AUTOMATIC;
};

/**
 * Check if template is manual
 */
export const isManualTemplate = (templateKey) => {
  return templateKey in WHATSAPP_TEMPLATES_CONFIG.MANUAL;
};

/**
 * Get template configuration by key
 */
export const getTemplateConfig = (templateKey) => {
  return (
    WHATSAPP_TEMPLATES_CONFIG.AUTOMATIC[templateKey] ||
    WHATSAPP_TEMPLATES_CONFIG.MANUAL[templateKey] ||
    null
  );
};

/**
 * Get template name by key (for API calls)
 */
export const getTemplateNameByKey = (templateKey) => {
  const template = getTemplateConfig(templateKey);
  return template?.templateName || null;
};

/**
 * Category counts
 */
export const TEMPLATE_COUNTS = {
  automatic: Object.keys(WHATSAPP_TEMPLATES_CONFIG.AUTOMATIC).length,
  manual: Object.keys(WHATSAPP_TEMPLATES_CONFIG.MANUAL).length,
  total:
    Object.keys(WHATSAPP_TEMPLATES_CONFIG.AUTOMATIC).length +
    Object.keys(WHATSAPP_TEMPLATES_CONFIG.MANUAL).length,
};
